import { Button, TextInput, Tile } from "carbon-components-react"
import { useEffect, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import UIShellPagination from "../../components/UIShellPagination"
import { bulkDeleteCategory, createCategory, fetchAllCategoryByParent } from "../../redux/actions/categoryAction"

function CategoryChildPage({ dataTableChildList, categoryParentId, isLoading, onViewCategoryDetail }) {
    const dispatch = useDispatch()
    const [pageState, setPageState] = useState({
        isAdding: false,
        categoryName: undefined
    })

    const createChildCategory = async () => {
        dispatch(createCategory({
            categoryName: pageState.categoryName,
            categoryParentId
        }, () => {
            setPageState({
                isAdding: false,
                categoryName: undefined
            })

            dispatch(fetchAllCategoryByParent({ categoryParentId }))
        }))
    }

    useEffect(() => {

    }, [categoryParentId])

    return (
        <>
            {!pageState.isAdding &&
                <>
                    <Button kind="ghost" onClick={() => setPageState((v) => ({ ...v, isAdding: true }))}>Add Child</Button>
                </>
                ||
                <Tile>
                    <TextInput
                        labelText="Child Category Name"
                        value={pageState.categoryName}
                        onChange={(v) => setPageState((_state) => ({ ..._state, categoryName: v.target.value }))}
                        style={{ marginBottom: '1rem' }}
                    />
                    <Button onClick={() => createChildCategory()} disabled={isLoading}>Add</Button>
                    <Button kind="secondary" onClick={() => setPageState((v) => ({ ...v, isAdding: false }))}>Cancel</Button>
                </Tile>
            }

            <CategoryChildList
                dataTableChildList={dataTableChildList}
                categoryParentId={categoryParentId}
                onViewCategoryDetail={onViewCategoryDetail} />
        </>
    )
}

const CategoryChildList = ({ dataTableChildList, categoryParentId, onViewCategoryDetail }) => {
    const dispatch = useDispatch()
    const headers = [
        {
            key: 'categoryName',
            header: 'Category Name',
        },
    ]

    const searchTable = () => { }
    const bulkDelete = async (_items) => {
        dispatch(bulkDeleteCategory({
            categoryIds: _items.map((v) => ({
                _id: v.id
            }))
        }, () => dispatch(fetchAllCategoryByParent({ categoryParentId }))))
    }

    const viewCategoryDetail = (_data) => {
        const categoryId = _data[0].id.split(":")[0]
        const categoryName = _data.filter(v => v.info.header === 'categoryName')[0]?.value

        onViewCategoryDetail({
            categoryId,
            categoryName
        })
    }

    useEffect(() => {
        dispatch(fetchAllCategoryByParent({ categoryParentId }))
    }, [categoryParentId])

    return (
        <>
            {dataTableChildList && dataTableChildList.filteredData?.length > 0 &&
                <UIShellPagination
                    dataTableList={dataTableChildList?.filteredData}
                    headers={headers}
                    searchTable={searchTable}
                    bulkDelete={bulkDelete}
                    createForm={() => alert(1)}
                    viewDetail={viewCategoryDetail}
                    withPagination={false}
                    withCreatable={false}
                    withTitle={false}
                    styles={{
                        grid: {
                            padding: 0
                        }
                    }}
                />
            }
        </>
    )
}


const mapStateToProps = state => {
    return {
        dataTableChildList: state.categoryReducer.dataTableChildList
    }
}

export default connect(mapStateToProps)(CategoryChildPage)